import {
  deleteAxios,
  getAxios,
  postAxios,
  putAxios,
} from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";

export function getUserData(callback: Function, errorCallback: Function) {
  return getAxios(apiNames.PROFMANAG, true, "/customers/profiles")
    .then((response: any) => {
      callback(response);
    })
    .catch((error: any) => {
      errorCallback(error);
    });
}

export function putPreferencesData(
  data: any,
  callback: Function,
  errorCallback: Function
) {
  putAxios(apiNames.PROFMANAG, true, "/customers/profiles/preferences", data)
    .then((response: any) => {
      callback(response);
    })
    .catch((error: any) => {
      errorCallback(error);
    });
}
